import * as actions from '../actions/currentUiSettingsActionTypes';


const initialState = {     
  csOverviewSearchCustomer: 1,
  csOverviewSearchSupplier: 1,
  csOverviewSearchContact: 1,
  csOverviewSearchMember: 1,
  csOverviewSearchActive: 1,
  csOverviewSearchInactive: 0,
  csOverviewSearchTerm: '',
  csOverviewSearchKeywords: [],
  csExportFilterOpen: true,
  csExportExportOpen: true,
  csExportSearchCustomer: 1,
  csExportSearchSupplier: 1,
  csExportSearchContact: 1,
  csExportSearchMember: 1,
  csExportSearchActive: 1,
  csExportSearchInactive: 1,
  csExportSearchTerm: '',
  csExportSearchKeywords: [],
  csExportIncludeBasedata: 1,
  csExportIncludeGeneral: 1,
  csExportIncludeAddress: 1,
  csExportIncludeContact: 1,
  csExportIncludeContactPerson: 1,
  csExportIncludeBilling: 1,
  csExportIncludeMember: 1,
  csExportIncludePostalAddress: 1,
  csExportIncludeUserAdministration: 1,
  csExportIncludeNotice: 1,
  invoiveMembershipFilterOpen: true,
  invoiveMembershipStarting: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  invoiveMembershipEnding: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  invoiveMembershipCategories: [],
  invoiceOverviewFilterOpen: true,
  invoiceOverviewInvoiceStatus: [],
  invoiceOverviewAccountingStatus: [],
  invoiceOverviewSearchTerm: '',
  invoiceOverviewStarting: new Date(new Date().getFullYear(), 0, 1),
  invoiceOverviewEnding: new Date(new Date().getFullYear(), 11, 31),
  invoiceOverviewRegister: 0,
  invoiceOverviewYear: new Date().getFullYear(),
  invoiceOverviewStartNumber: null,
  invoiceOverviewEndNumber: null,
  invoiceOverviewSepa: 1,

  budgetForecastSelectedYear: 0,

  budgetForecastSumAutoWidth: true,
  budgetForecastSumAutoExpandAll: false,
  budgetForecastSumSelectMonthOption: 0,
  budgetForecastSumShowMonthlyDifference: 0,
  budgetForecastSumShowAnnotation: false,
  budgetForecastSumShowYears: false,
  budgetForecastSumCharts: false,
  budgetForecastShowSummary: false,
  budgetForecastShowForecast: false,
  budgetForecastShowYearToDate: false,

  budgetForecastOverviewActive: 1,
  budgetForecastOverviewInactive: 0,
  budgetForecastOverviewSearchTerm: '',

  budgetDetailConfigCollapsed: false,
  budgetDetailNoteFieldCollapsed: false,
  budgetDetailSingleMonthDetailsCollapsed: false,

  parishMassTypesListActiveFilter: 1,
  parishMassTypesListInactiveFilter: 0,
  parishIntentionTypesListActiveFilter: 1,
  parishIntentionTypesListInactiveFilter: 0,

  empSettingsTimeModelActiveFilter: 1,
  empSettingsTimeModelInactiveFilter: 1,

  timeCalendarSearchMonth: 0,
  timeCalendarSearchGroup: '',
  timeCalendarSearchEmployee: '',
  timeCalendarSearchWork: 0,

  fraOverviewSearchActive: 1,
  fraOverviewSearchInactive: 0, 
  fraOverviewSearchMember: 1,
  fraOverviewSearchNotMember: 1,
  fraOverviewSearchOrderByLveNumber: 1,
  fraOverviewSearchTerm: '',

  treeConfigOverviewSearchActive: 1,
  treeConfigOverviewSearchInactive: 1,
  treeConfigOverviewSearchTemplate: 1,
  treeConfigOverviewSearchProduction: 1,
  treeConfigOverviewSearchTerm: '',

  treeProjectOverviewSearchActive: 1,
  treeProjectOverviewSearchInactive: 1,
  treeProjectOverviewSearchTerm: '',
  treeProjectOverviewSearchCs: 0,

  treeProjectBranchListFilterName: '',
  treeProjectBranchListFilterType: '',
  treeProjectBranchListFilterStatus: '',
  treeProjectBranchListFilterShowDeleted: '',
  treeProjectCodeFilterVisibleStatus: 0,
  //treeProjectBranchListFilterArchive: 0,


  todoItemListFilterStatuses: [],
  todoItemListFilterTypes: [],
  todoItemListFilterStarting: '',
  todoItemListFilterEnding: '',
  todoOrderOverviewSearchActive: 1,
  todoOrderOverviewSearchInactive: 1,
  todoOrderOverviewSearchTerm: '',
  todoOrderOverviewSearchCs: '',
  todoOrderOverviewSearchFra: '',
  todoItemListFilterCollapsed: 0,


  dataProjectItemListFilterSearchTerm: null,
  dataProjectItemListFilterIsQuarter1: 0,
  dataProjectItemListFilterIsQuarter2: 0,
  dataProjectItemListFilterIsQuarter3: 0,
  dataProjectItemListFilterIsQuarter4: 0,

  dataProjectItemListFilterChangeStarting: null,
  dataProjectItemListFilterChangeEnding: null,
  dataProjectItemListFilterMultiSelectStatus: [],


  dataProjectTreeFilterMultiSelectStatus: [],
  dataProjectTreeFilterMultiSelectTrafficLight: [],
  dataProjectTreeFilterShowArchivedStatus: 0,
  dataProjectTreeBranchOnlyNotNull: 0,
  dataProjectTreeFilterCollapsed: 0,

  
  convOverviewCheckboxOpen: 1,
  convOverviewCheckboxElaboration: 1,
  convOverviewCheckboxClose: 0,
  convOverviewCheckboxError: 1,
  convOverviewCheckboxDeleteRequest: 0,
  convOverviewCheckboxDeleted: 0,
  convOverviewSearchTerm: null,

  empOverviewSearchActive: 1,
  empOverviewSearchInactive: 0,
  empOverviewSearchText: '',


  todoOverviewFilterOpen: true,
  todoOverviewAlertFilter: 1,       /*deprecated*/
  todoOverviewTaskFilter: 1,        /*deprecated*/
  todoOverviewOtherFilter: 1,       /*deprecated*/
  todoOverviewCheckTodoFilter: 1,   /*deprecated*/
  todoOverviewCheckObjectFilter: 1, /*deprecated*/
  todoOverviewTextFilter: "",

  todoOverviewStartingFilter: "1900-01-01",
  todoOverviewEndingFilter: "1900-01-01",

  todoOverviewStartingObjectFilter: "1900-01-01",   /*deprecated*/
  todoOverviewEndingObjectFilter: "1900-01-01",     /*deprecated*/

  todoOverviewStatusFilter: [],
  todoOverviewShowNotAssignedFilter: 0,

  todoOverviewResponsible: [],
  todoOverviewMonitoring: [],

  todoOverviewFlag: [],
  todoOverviewPersonalFlag: [],

  todoOverviewModuleFilter: [],
  todoOverviewDetailTypeFilter: [],
  todoOverviewProjectFilter: [],
  todoOverviewTodoFilter: [],


  employeeHistoryMonth: '2000-01-01',
  employeeHistoryActive: 1,
  employeeHistoryInactive: 0,
  employeeHistoryTimeTrackingActive: 1,
  employeeHistoryTimeTrackingInactive: 0,


  teamVacationOverviewColumnMode: 1,



  timeTrackCurrentListOrderByLastname: 0,
  timeTrackCurrentListCheckedIn: 1,
  timeTrackCurrentListCheckedOut: 1,
  timeTrackCurrentListBreakTime: 1,
  timeTrackCurrentListSearchTerm: '',
  timeTrackCurrentListGroup: 'ALL',

  timemanagerMonthDaySwitch: 'DAY',
  timemanagerDate: new Date(),
  timemanagerMonth: null,
  timemanagerEmployeeRid: 0,

  teamEndOfMonthOverviewMonth: '2000-01',
  teamEndOfMonthOverviewOpen: 1,
  teamEndOfMonthOverviewCloseByEmp: 1,
  teamEndOfMonthOverviewCloseByTL: 1,
  teamEndOfMonthOverviewCloseByHR: 1,
  teamEndOfMonthOverviewTextFilter: null,

  maxFileUploadSize: 10,

  leftSideMenuIsMinimized: false,

  programVersion: 0
}


function currentUiSettings(state = initialState, action) {      
  switch (action.type) {
    case actions.CS_OVERVIEW_SEARCH_CUSTOMER:
      return {
        ...state, 
        csOverviewSearchCustomer: action.csOverviewSearchCustomer
      }
    case actions.CS_OVERVIEW_SEARCH_SUPPLIER:
      return {
        ...state, 
        csOverviewSearchSupplier: action.csOverviewSearchSupplier
      }
    case actions.CS_OVERVIEW_SEARCH_CONTACT:
      return {
        ...state, 
        csOverviewSearchContact: action.csOverviewSearchContact
      }
    case actions.CS_OVERVIEW_SEARCH_MEMBER:
      return {
        ...state,
        csOverviewSearchMember: action.csOverviewSearchMember
      }
    case actions.CS_OVERVIEW_SEARCH_ACTIVE:
        return {
          ...state, 
          csOverviewSearchActive: action.csOverviewSearchActive
        }
    case actions.CS_OVERVIEW_SEARCH_INACTIVE:
      return {
        ...state, 
        csOverviewSearchInactive: action.csOverviewSearchInactive
      }
    case actions.CS_OVERVIEW_SEARCH_TERM:
      return {
        ...state, 
        csOverviewSearchTerm: action.csOverviewSearchTerm
      }

    case actions.CS_OVERVIEW_SEARCH_KEYWORDS:
      return {
        ...state,
        csOverviewSearchKeywords: action.csOverviewSearchKeywords
      }

    case actions.CS_EXPORT_FILTER_OPEN:
      return {
        ...state,
        csExportFilterOpen: action.csExportFilterOpen
      }

    case actions.INVOIVE_MEMBERSHIP_FILTER_OPEN:
      return {
        ...state,
        invoiveMembershipFilterOpen: action.invoiveMembershipFilterOpen
      }

    case actions.INVOIVE_MEMBERSHIP_STARTING:
      return {
        ...state,
        invoiveMembershipStarting: action.invoiveMembershipStarting
      }

    case actions.INVOIVE_MEMBERSHIP_ENDING:
      return {
        ...state,
        invoiveMembershipEnding: action.invoiveMembershipEnding
      }

    case actions.INVOIVE_MEMBERSHIP_CATEGORIES:
      return {
        ...state,
        invoiveMembershipCategories: action.invoiveMembershipCategories
      }

    case actions.INVOICE_OVERVIEW_FILTER_OPEN:
      return {
        ...state,
        invoiceOverviewFilterOpen: action.invoiceOverviewFilterOpen
      }

    case actions.INVOICE_OVERVIEW_INVOICE_STATUS:
      return {
        ...state,
        invoiceOverviewInvoiceStatus: action.invoiceOverviewInvoiceStatus
      }

    case actions.INVOICE_OVERVIEW_ACCOUNTING_STATUS:
      return {
        ...state,
        invoiceOverviewAccountingStatus: action.invoiceOverviewAccountingStatus
      }

    case actions.INVOICE_OVERVIEW_SEARCH_TERM:
      return {
        ...state,
        invoiceOverviewSearchTerm: action.invoiceOverviewSearchTerm
      }

    case actions.INVOICE_OVERVIEW_STARTING:
      return {
        ...state,
        invoiceOverviewStarting: action.invoiceOverviewStarting
      }

    case actions.INVOICE_OVERVIEW_ENDING:
      return {
        ...state,
        invoiceOverviewEnding: action.invoiceOverviewEnding
      }

    case actions.INVOICE_OVERVIEW_REGISTER:
      return {
        ...state,
        invoiceOverviewRegister: action.invoiceOverviewRegister
      }

    case actions.INVOICE_OVERVIEW_YEAR:
      return {
        ...state,
        invoiceOverviewYear: action.invoiceOverviewYear
      }

    case actions.INVOICE_OVERVIEW_START_NUMBER:
      return {
        ...state,
        invoiceOverviewStartNumber: action.invoiceOverviewStartNumber
      }

    case actions.INVOICE_OVERVIEW_END_NUMBER:
      return {
        ...state,
        invoiceOverviewEndNumber: action.invoiceOverviewEndNumber
      }

    case actions.INVOICE_OVERVIEW_SEPA:
      return {
        ...state,
        invoiceOverviewSepa: action.invoiceOverviewSepa
      }

    case actions.CS_EXPORT_EXPORT_OPEN:
      return {
        ...state,
        csExportExportOpen: action.csExportExportOpen
      }

    case actions.CS_EXPORT_SEARCH_CUSTOMER:
      return {
        ...state,
        csExportSearchCustomer: action.csExportSearchCustomer
      }

    case actions.CS_EXPORT_SEARCH_SUPPLIER:
      return {
        ...state,
        csExportSearchSupplier: action.csExportSearchSupplier
      }

    case actions.CS_EXPORT_SEARCH_CONTACT:
      return {
        ...state,
        csExportSearchContact: action.csExportSearchContact
      }

    case actions.CS_EXPORT_SEARCH_MEMBER:
      return {
        ...state,
        csExportSearchMember: action.csExportSearchMember
      }

    case actions.CS_EXPORT_SEARCH_ACTIVE:
      return {
        ...state,
        csExportSearchActive: action.csExportSearchActive
      }

    case actions.CS_EXPORT_SEARCH_INACTIVE:
      return {
        ...state,
        csExportSearchInactive: action.csExportSearchInactive
      }

    case actions.CS_EXPORT_SEARCH_TERM:
      return {
        ...state,
        csExportSearchTerm: action.csExportSearchTerm
      }

    case actions.CS_EXPORT_SEARCH_KEYWORDS:
      return {
        ...state,
        csExportSearchKeywords: action.csExportSearchKeywords
      }

    case actions.CS_EXPORT_INCLUDE_BASEDATA:
      return {
        ...state,
        csExportIncludeBasedata: action.csExportIncludeBasedata
      }

    case actions.CS_EXPORT_INCLUDE_GENERAL:
      return {
        ...state,
        csExportIncludeGeneral: action.csExportIncludeGeneral
      }

    case actions.CS_EXPORT_INCLUDE_ADDRESS:
      return {
        ...state,
        csExportIncludeAddress: action.csExportIncludeAddress
      }

    case actions.CS_EXPORT_INCLUDE_CONTACT:
      return {
        ...state,
        csExportIncludeContact: action.csExportIncludeContact
      }

    case actions.CS_EXPORT_INCLUDE_CONTACT_PERSON:
      return {
        ...state,
        csExportIncludeContactPerson: action.csExportIncludeContactPerson
      }

    case actions.CS_EXPORT_INCLUDE_BILLING:
      return {
        ...state,
        csExportIncludeBilling: action.csExportIncludeBilling
      }

    case actions.CS_EXPORT_INCLUDE_MEMBER:
      return {
        ...state,
        csExportIncludeMember: action.csExportIncludeMember
      }

    case actions.CS_EXPORT_INCLUDE_POSTAL_ADDRESS:
      return {
        ...state,
        csExportIncludePostalAddress: action.csExportIncludePostalAddress
      }

    case actions.CS_EXPORT_INCLUDE_USER_ADMINISTRATION:
      return {
        ...state,
        csExportIncludeUserAdministration: action.csExportIncludeUserAdministration
      }

    case actions.CS_EXPORT_INCLUDE_NOTICE:
      return {
        ...state,
        csExportIncludeNotice: action.csExportIncludeNotice
      }

    case actions.BUDGET_FORECAST_SELECTED_YEAR:
      return {
        ...state, 
        budgetForecastSelectedYear: action.budgetForecastSelectedYear
      }



    case actions.BUDGET_FORECAST_SUM_AUTO_WIDTH:
      return {
        ...state, 
        budgetForecastSumAutoWidth: action.budgetForecastSumAutoWidth
      }
    case actions.BUDGET_FORECAST_SUM_AUTO_EXPAND_ALL:
      return {
        ...state, 
        budgetForecastSumAutoExpandAll: action.budgetForecastSumAutoExpandAll
      }
    case actions.BUDGET_FORECAST_SUM_SELECT_MONTH_OPTION:
      return {
        ...state, 
        budgetForecastSumSelectMonthOption: action.budgetForecastSumSelectMonthOption
      }
    case actions.BUDGET_FORECAST_SUM_SHOW_MONTHLY_DIFFERENCE:
      return {
        ...state, 
        budgetForecastSumShowMonthlyDifference: action.budgetForecastSumShowMonthlyDifference
      }
    case actions.BUDGET_FORECAST_SUM_SHOW_MONTHLY_DIFFERENCE:
      return {
        ...state, 
        budgetForecastSumShowMonthlyDifference: action.budgetForecastSumShowMonthlyDifference
      }
    case actions.BUDGET_FORECAST_SUM_SHOW_ANNOTATION:
      return {
        ...state, 
        budgetForecastSumShowAnnotation: action.budgetForecastSumShowAnnotation
      }
    case actions.BUDGET_FORECAST_SUM_SHOW_YEAR:
      return {
        ...state, 
        budgetForecastSumShowYears: action.budgetForecastSumShowYears
      }
    case actions.BUDGET_FORECAST_SUM_CHARTS:
      return {
        ...state, 
        budgetForecastSumCharts: action.budgetForecastSumCharts
      }
    case actions.BUDGET_FORECAST_SHOW_SUMMARY:
      return {
        ...state, 
        budgetForecastShowSummary: action.budgetForecastShowSummary
      }



    case actions.BUDGET_FORECAST_SHOW_YEAR_TO_DATE:
      return {
        ...state, 
        budgetForecastShowYearToDate: action.budgetForecastShowYearToDate
      }

    case actions.BUDGET_FORECAST_SHOW_FORECAST:
      return {
        ...state, 
        budgetForecastShowForecast: action.budgetForecastShowForecast
      }




    case actions.BUDGET_FORECAST_OVERVIEW_ACTIVE:
      return {
        ...state, 
        budgetForecastOverviewActive: action.budgetForecastOverviewActive
      }
    case actions.BUDGET_FORECAST_OVERVIEW_INACTIVE:
      return {
        ...state, 
        budgetForecastOverviewInactive: action.budgetForecastOverviewInactive
      }
    case actions.BUDGET_FORECAST_OVERVIEW_SEARCH_TERM:
      return {
        ...state, 
        budgetForecastOverviewSearchTerm: action.budgetForecastOverviewSearchTerm
      }


    case actions.BUDGET_DETAIL_CONFIG_COLLAPSED:
      return {
        ...state, 
        budgetDetailConfigCollapsed: action.budgetDetailConfigCollapsed
      }
    case actions.BUDGET_DETAIL_NOTE_FIELD_COLLAPSED:
      return {
        ...state, 
        budgetDetailNoteFieldCollapsed: action.budgetDetailNoteFieldCollapsed
      }
    case actions.BUDGET_DETAIL_SINGLE_MONTH_DETAILS_COLLAPSED:
      return {
        ...state, 
        budgetDetailSingleMonthDetailsCollapsed: action.budgetDetailSingleMonthDetailsCollapsed
      }


    case actions.TODO_SETTINGS_NOTIFICATION_GROUP_LIST_ACTIVE_FILTER:
      return {
        ...state, 
        todoSettingsNotificationGroupListActiveFilter: action.todoSettingsNotificationGroupListActiveFilter
      }
    case actions.TODO_SETTINGS_NOTIFICATION_GROUP_LIST_INACTIVE_FILTER:
      return {
        ...state, 
        todoSettingsNotificationGroupListInactiveFilter: action.todoSettingsNotificationGroupListInactiveFilter
      }

    case actions.TODO_SETTINGS_NOTIFICATION_TYPE_LIST_ACTIVE_FILTER:
      return {
        ...state, 
        todoSettingsNotificationTypeListActiveFilter: action.todoSettingsNotificationTypeListActiveFilter
      }
    case actions.TODO_SETTINGS_NOTIFICATION_TYPE_LIST_INACTIVE_FILTER:
      return {
        ...state, 
        todoSettingsNotificationTypeListInactiveFilter: action.todoSettingsNotificationTypeListInactiveFilter
      }

    case actions.TODO_SETTINGS_NOTIFICATION_STATE_LIST_ACTIVE_FILTER:
      return {
        ...state, 
        todoSettingsNotificationStateListActiveFilter: action.todoSettingsNotificationStateListActiveFilter
      }
    case actions.TODO_SETTINGS_NOTIFICATION_STATE_LIST_INACTIVE_FILTER:
      return {
        ...state, 
        todoSettingsNotificationStateListInactiveFilter: action.todoSettingsNotificationStateListInactiveFilter
      }

///

    case actions.PARISH_MASS_TYPES_LIST_ACTIVE_FILTER:
      return {
        ...state, 
        parishMassTypesListActiveFilter: action.parishMassTypesListActiveFilter
      }
    case actions.PARISH_MASS_TYPES_LIST_INACTIVE_FILTER:
      return {
        ...state, 
        parishMassTypesListInactiveFilter: action.parishMassTypesListInactiveFilter
      }
    case actions.PARISH_INTENTION_TYPES_LIST_ACTIVE_FILTER:
      return {
        ...state, 
        parishIntentionTypesListActiveFilter: action.parishIntentionTypesListActiveFilter
      }
    case actions.PARISH_INTENTION_TYPES_LIST_INACTIVE_FILTER:
      return {
        ...state, 
        parishIntentionTypesListInactiveFilter: action.parishIntentionTypesListInactiveFilter
      }

///

    case actions.EMP_SETTINGS_TIME_MODEL_ACTIVE_FILTER:
      return {
        ...state, 
        empSettingsTimeModelActiveFilter: action.empSettingsTimeModelActiveFilter
      }
    case actions.EMP_SETTINGS_TIME_MODEL_INACTIVE_FILTER:
      return {
        ...state, 
        empSettingsTimeModelInactiveFilter: action.empSettingsTimeModelInactiveFilter
      }

    case actions.EMP_SETTINGS_DAY_PLAN_ACTIVE_FILTER:
      return {
        ...state, 
        empSettingsDayPlanActiveFilter: action.empSettingsDayPlanActiveFilter
      }
    case actions.EMP_SETTINGS_DAY_PLAN_INACTIVE_FILTER:
      return {
        ...state, 
        empSettingsDayPlanInactiveFilter: action.empSettingsDayPlanInactiveFilter
      }

    case actions.EMP_SETTINGS_FLEX_ACTIVE_FILTER:
      return {
        ...state, 
        empSettingsFlexActiveFilter: action.empSettingsFlexActiveFilter
      }
    case actions.EMP_SETTINGS_FLEX_INACTIVE_FILTER:
      return {
        ...state, 
        empSettingsFlexInactiveFilter: action.empSettingsFlexInactiveFilter
      }


    case actions.TIME_CALENDAR_SEARCH_MONTH:
      return {
        ...state, 
        timeCalendarSearchMonth: action.timeCalendarSearchMonth
      }
    case actions.TIME_CALENDAR_SEARCH_GROUP:
      return {
        ...state, 
        timeCalendarSearchGroup: action.timeCalendarSearchGroup
      }
    case actions.TIME_CALENDAR_SEARCH_EMPLOYEE:
        return {
          ...state, 
          timeCalendarSearchEmployee: action.timeCalendarSearchEmployee
        }
    case actions.TIME_CALENDAR_SEARCH_WORK:
        return {
          ...state, 
          timeCalendarSearchWork: action.timeCalendarSearchWork
        }


    case actions.FRA_OVERVIEW_SEARCH_ACTIVE:
      return {
        ...state, 
        fraOverviewSearchActive: action.fraOverviewSearchActive
      }
    case actions.FRA_OVERVIEW_SEARCH_INACTIVE:
      return {
        ...state, 
        fraOverviewSearchInactive: action.fraOverviewSearchInactive
      }
    case actions.FRA_OVERVIEW_SEARCH_MEMBER:
        return {
          ...state, 
          fraOverviewSearchMember: action.fraOverviewSearchMember
        }
    case actions.FRA_OVERVIEW_SEARCH_NOT_MEMBER:
      return {
        ...state, 
        fraOverviewSearchNotMember: action.fraOverviewSearchNotMember
      }
    case actions.FRA_OVERVIEW_SEARCH_ORDER_BY_LVE_NUMBER:
        return {
          ...state, 
          fraOverviewSearchOrderByLveNumber: action.fraOverviewSearchOrderByLveNumber
        }
    case actions.FRA_OVERVIEW_SEARCH_TERM:
        return {
          ...state, 
          fraOverviewSearchTerm: action.fraOverviewSearchTerm
        }

    case actions.FRA_MEMBERSHIP_OVERVIEW_SEARCH_TERM:
        return {
          ...state, 
          fraMembershipOverviewSearchTerm: action.fraMembershipOverviewSearchTerm
        }
  

    case actions.TREE_CONFIG_OVERVIEW_SEARCH_ACTIVE:
      return {
        ...state, 
        treeConfigOverviewSearchActive: action.treeConfigOverviewSearchActive
      }
    case actions.TREE_CONFIG_OVERVIEW_SEARCH_INACTIVE:
      return {
        ...state, 
        treeConfigOverviewSearchInactive: action.treeConfigOverviewSearchInactive
      }
    case actions.TREE_CONFIG_OVERVIEW_SEARCH_TEMPLATE:
      return {
        ...state, 
        treeConfigOverviewSearchTemplate: action.treeConfigOverviewSearchTemplate
      }
    case actions.TREE_CONFIG_OVERVIEW_SEARCH_PRODUCTION:
      return {
        ...state, 
        treeConfigOverviewSearchProduction: action.treeConfigOverviewSearchProduction
      }
    case actions.TREE_CONFIG_OVERVIEW_SEARCH_TERM:
      return {
        ...state, 
        treeConfigOverviewSearchTerm: action.treeConfigOverviewSearchTerm
      }      


    case actions.TREE_PROJECT_OVERVIEW_SEARCH_ACTIVE:
      return {
        ...state, 
        treeProjectOverviewSearchActive: action.treeProjectOverviewSearchActive
      }
    case actions.TREE_PROJECT_OVERVIEW_SEARCH_INACTIVE:
      return {
        ...state, 
        treeProjectOverviewSearchInactive: action.treeProjectOverviewSearchInactive
      }
    case actions.TREE_PROJECT_OVERVIEW_SEARCH_TERM:
      return {
        ...state, 
        treeProjectOverviewSearchTerm: action.treeProjectOverviewSearchTerm
      }
    case actions.TREE_PROJECT_OVERVIEW_SEARCH_CS:
      return {
        ...state, 
        treeProjectOverviewSearchCs: action.treeProjectOverviewSearchCs
      }

    case actions.TODO_ORDER_OVERVIEW_SEARCH_ACTIVE:
      return {
        ...state,
        todoOrderOverviewSearchActive: action.todoOrderOverviewSearchActive
      };

    case actions.TODO_ORDER_OVERVIEW_SEARCH_INACTIVE:
      return {
        ...state,
        todoOrderOverviewSearchInactive: action.todoOrderOverviewSearchInactive
      };

    case actions.TODO_ORDER_OVERVIEW_SEARCH_TERM:
      return {
        ...state,
        todoOrderOverviewSearchTerm: action.todoOrderOverviewSearchTerm
      };

    case actions.TODO_ORDER_OVERVIEW_SEARCH_CS:
      return {
        ...state,
        todoOrderOverviewSearchCs: action.todoOrderOverviewSearchCs
      };

    case actions.TODO_ORDER_OVERVIEW_SEARCH_FRA:
      return {
        ...state,
        todoOrderOverviewSearchFra: action.todoOrderOverviewSearchFra
      };
      
    
    case actions.TREE_PROJECT_BRANCH_LIST_FILTER_NAME:
      return {
        ...state, 
        treeProjectBranchListFilterName: action.treeProjectBranchListFilterName
      }
    case actions.TREE_PROJECT_BRANCH_LIST_FILTER_TYPE:
      return {
        ...state, 
        treeProjectBranchListFilterType: action.treeProjectBranchListFilterType
      }
    case actions.TREE_PROJECT_BRANCH_LIST_FILTER_STATUS:
      return {
        ...state, 
        treeProjectBranchListFilterStatus: action.treeProjectBranchListFilterStatus
      } 

    case actions.TREE_PROJECT_BRANCH_LIST_FILTER_SHOW_DELETED:
      return {
        ...state, 
        treeProjectBranchListFilterShowDeleted: action.treeProjectBranchListFilterShowDeleted
      } 

    case actions.TREE_PROJECT_CODE_FILTER_VISIBLE_STATUS:
      return {
        ...state, 
        treeProjectCodeFilterVisibleStatus: action.treeProjectCodeFilterVisibleStatus
      } 
      /*
    case actions.TREE_PROJECT_BRANCH_LIST_FILTER_ARCHIVE:
      return {
        ...state, 
        treeProjectBranchListFilterArchive: action.treeProjectBranchListFilterArchive
      }
        */
      

    case actions.DATA_PROJECT_ITEM_LIST_FILTER_SEARCH_TERM:
      return {
        ...state, 
        dataProjectItemListFilterSearchTerm: action.dataProjectItemListFilterSearchTerm
      }
    case actions.DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER1:
      return {
        ...state, 
        dataProjectItemListFilterIsQuarter1: action.dataProjectItemListFilterIsQuarter1
      }
    case actions.DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER2:
      return {
        ...state, 
        dataProjectItemListFilterIsQuarter2: action.dataProjectItemListFilterIsQuarter2
      }
    case actions.DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER3:
      return {
        ...state, 
        dataProjectItemListFilterIsQuarter3: action.dataProjectItemListFilterIsQuarter3
      }
    case actions.DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER4:
      return {
        ...state, 
        dataProjectItemListFilterIsQuarter4: action.dataProjectItemListFilterIsQuarter4
      }



    case actions.TODO_ITEM_LIST_FILTER_STATUSES:
      return {
        ...state, 
        todoItemListFilterStatuses: action.todoItemListFilterStatuses
      }
    
    case actions.TODO_ITEM_LIST_FILTER_TYPES:
      return {
        ...state, 
        todoItemListFilterTypes: action.todoItemListFilterTypes
      }

    case actions.TODO_ITEM_LIST_FILTER_STARTING:
      return {
        ...state, 
        todoItemListFilterStarting: action.todoItemListFilterStarting
      }
    
    case actions.TODO_ITEM_LIST_FILTER_ENDING:
      return {
        ...state, 
        todoItemListFilterEnding: action.todoItemListFilterEnding
      }

    case actions.TODO_ITEM_LIST_FILTER_COLLAPSED:
      return {
        ...state,
        todoItemListFilterCollapsed: action.todoItemListFilterCollapsed
      }

    

    case actions.DATA_PROJECT_ITEM_LIST_FILTER_CHANGE_STARTING:
      return {
        ...state, 
        dataProjectItemListFilterChangeStarting: action.dataProjectItemListFilterChangeStarting
      }
    case actions.DATA_PROJECT_ITEM_LIST_FILTER_CHANGE_ENDING:
      return {
        ...state, 
        dataProjectItemListFilterChangeEnding: action.dataProjectItemListFilterChangeEnding
      }
    case actions.DATA_PROJECT_ITEM_LIST_FILTER_MULTI_SELECT_STATUS:
      return {
        ...state, 
        dataProjectItemListFilterMultiSelectStatus: action.dataProjectItemListFilterMultiSelectStatus
      }
    



    case actions.DATA_PROJECT_TREE_FILTER_MULTI_SELECT_STATUS:
      return {
        ...state, 
        dataProjectTreeFilterMultiSelectStatus: action.dataProjectTreeFilterMultiSelectStatus
      }

    case actions.DATA_PROJECT_TREE_FILTER_MULTI_SELECT_TRAFFICLIGHT:
      return {
        ...state, 
        dataProjectTreeFilterMultiSelectTrafficLight: action.dataProjectTreeFilterMultiSelectTrafficLight
      }

    case actions.DATA_PROJECT_TREE_FILTER_SHOW_ARCHIVED_STATUS:
      return {
        ...state, 
        dataProjectTreeFilterShowArchivedStatus: action.dataProjectTreeFilterShowArchivedStatus
      }

    case actions.DATA_PROJECT_TREE_BRANCH_ONLY_NOT_NULL:
      return {
        ...state, 
        dataProjectTreeBranchOnlyNotNull: action.dataProjectTreeBranchOnlyNotNull
      }

    case actions.DATA_PROJECT_TREE_FILTER_COLLAPSED:
      return {
        ...state,
        dataProjectTreeFilterCollapsed: action.dataProjectTreeFilterCollapsed
      }






    case actions.TREE_PROJECT_AUTO_HIDE:
      return {
        ...state, 
        treeProjectAutoHide: action.treeProjectAutoHide
      }




      case actions.CONV_OVERVIEW_CHECKBOX_OPEN:
      return {
        ...state, 
        convOverviewCheckboxOpen: action.convOverviewCheckboxOpen
      }

      case actions.CONV_OVERVIEW_CHECKBOX_ELABORATION:
      return {
        ...state, 
        convOverviewCheckboxElaboration: action.convOverviewCheckboxElaboration
      }

      case actions.CONV_OVERVIEW_CHECKBOX_CLOSE:
      return {
        ...state, 
        convOverviewCheckboxClose: action.convOverviewCheckboxClose
      }

      case actions.CONV_OVERVIEW_CHECKBOX_ERROR:
      return {
        ...state, 
        convOverviewCheckboxError: action.convOverviewCheckboxError
      }

      case actions.CONV_OVERVIEW_CHECKBOX_DELETE_REQUEST:
      return {
        ...state, 
        convOverviewCheckboxDeleteRequest: action.convOverviewCheckboxDeleteRequest
      }

      case actions.CONV_OVERVIEW_CHECKBOX_DELETE:
        return {
          ...state, 
          convOverviewCheckboxDeleted: action.convOverviewCheckboxDeleted
        }

      case actions.CONV_OVERVIEW_SEARCH_TERM:
      return {
        ...state, 
        convOverviewSearchTerm: action.convOverviewSearchTerm
      }




      case actions.EMP_OVERVIEW_SEARCH_ACTIVE:
        return {
          ...state, 
          empOverviewSearchActive: action.empOverviewSearchActive
        }
      case actions.EMP_OVERVIEW_SEARCH_INACTIVE:
        return {
          ...state, 
          empOverviewSearchInactive: action.empOverviewSearchInactive
        }
      case actions.EMP_OVERVIEW_SEARCH_TEXT:
        return {
          ...state, 
          empOverviewSearchText: action.empOverviewSearchText
        }

      case actions.TODO_OVERVIEW_FILTER_OPEN:
        return {
          ...state, 
          todoOverviewFilterOpen: action.todoOverviewFilterOpen
        }
    
      /*deprecated*/
      case actions.TODO_OVERVIEW_ALERT_FILTER:
        return {
          ...state, 
          todoOverviewAlertFilter: action.todoOverviewAlertFilter
        }
      /*deprecated*/
      case actions.TODO_OVERVIEW_TASK_FILTER:
        return {
          ...state, 
          todoOverviewTaskFilter: action.todoOverviewTaskFilter
        }
      /*deprecated*/
      case actions.TODO_OVERVIEW_OTHER_FILTER:
        return {
          ...state, 
          todoOverviewOtherFilter: action.todoOverviewOtherFilter
        }

      /*deprecated*/
      case actions.TODO_OVERVIEW_CHECK_TODO_FILTER:
        return {
          ...state, 
          todoOverviewCheckTodoFilter: action.todoOverviewCheckTodoFilter
        }

      /*deprecated*/
      case actions.TODO_OVERVIEW_CHECK_OBJECT_FILTER:
        return {
          ...state, 
          todoOverviewCheckObjectFilter: action.todoOverviewCheckObjectFilter
        }

      case actions.TODO_OVERVIEW_TEXT_FILTER:
        return {
          ...state, 
          todoOverviewTextFilter: action.todoOverviewTextFilter
        }
      case actions.TODO_OVERVIEW_STARTING_FILTER:
        return {
          ...state, 
          todoOverviewStartingFilter: action.todoOverviewStartingFilter
        }
      case actions.TODO_OVERVIEW_ENDING_FILTER:
        return {
          ...state, 
          todoOverviewEndingFilter: action.todoOverviewEndingFilter
        }

      /*deprecated*/
      case actions.TODO_OVERVIEW_STARTING_OBJECT_FILTER:
        return {
          ...state, 
          todoOverviewStartingObjectFilter: action.todoOverviewStartingObjectFilter
        }
      /*deprecated*/
      case actions.TODO_OVERVIEW_ENDING_OBJECT_FILTER:
        return {
          ...state, 
          todoOverviewEndingObjectFilter: action.todoOverviewEndingObjectFilter
        }



      case actions.TODO_OVERVIEW_STATUS_FILTER:
        return {
          ...state, 
          todoOverviewStatusFilter: action.todoOverviewStatusFilter
        }
      case actions.TODO_OVERVIEW_SHOW_NOT_ASSIGNED_FILTER:
        return {
          ...state, 
          todoOverviewShowNotAssignedFilter: action.todoOverviewShowNotAssignedFilter
        }

      case actions.TODO_OVERVIEW_RESPONSIBLE:
        return {
          ...state, 
          todoOverviewResponsible: action.todoOverviewResponsible
        }
      case actions.TODO_OVERVIEW_MONITORING:
        return {
          ...state, 
          todoOverviewMonitoring: action.todoOverviewMonitoring
        }

      case actions.TODO_OVERVIEW_FLAG:
        return {
          ...state, 
          todoOverviewFlag: action.todoOverviewFlag
        }

      case actions.TODO_OVERVIEW_PERSONAL_FLAG:
        return {
          ...state, 
          todoOverviewPersonalFlag: action.todoOverviewPersonalFlag
        }      

      case actions.TODO_OVERVIEW_MODULE_FILTER:
        return {
          ...state, 
          todoOverviewModuleFilter: action.todoOverviewModuleFilter
        }
      case actions.TODO_OVERVIEW_DETAILTYPE_FILTER:
        return {
          ...state, 
          todoOverviewDetailTypeFilter: action.todoOverviewDetailTypeFilter
        }
      case actions.TODO_OVERVIEW_PROJECT_FILTER:
        return {
          ...state, 
          todoOverviewProjectFilter: action.todoOverviewProjectFilter
        }
      case actions.TODO_OVERVIEW_TODO_FILTER:
        return {
          ...state, 
          todoOverviewTodoFilter: action.todoOverviewTodoFilter
        } 


        



      case actions.DATA_SEARCH_CREATD_FROM_FILTER:
        return {
          ...state, 
          dataSearchCreatedFromFilter: action.dataSearchCreatedFromFilter
        } 
      case actions.DATA_SEARCH_CREATED_TO_FILTER:
        return {
          ...state, 
          dataSearchCreatedToFilter: action.dataSearchCreatedToFilter
        } 
      case actions.DATA_SEARCH_VALID_FROM_FILTER:
        return {
          ...state, 
          dataSearchValidFromFilter: action.dataSearchValidFromFilter
        }                         
      case actions.DATA_SEARCH_VALID_TO_FILTER:
        return {
          ...state, 
          dataSearchValidToFilter: action.dataSearchValidToFilter
        } 
      case actions.DATA_SEARCH_STATUS_FILTER:
        return {
          ...state, 
          dataSearchStatusFilter: action.dataSearchStatusFilter
        }


      case actions.DATA_SEARCH_MODULE_FILTER:
        return {
          ...state, 
          dataSearchModuleFilter: action.dataSearchModuleFilter
        }
      case actions.DATA_SEARCH_KEYWORD_LIST:
        return {
          ...state,
          dataSearchKeywordList: action.dataSearchKeywordList
        }
      case actions.DATA_SEARCH_DETAIL_TYPE_FILTER:
        return {
          ...state, 
          dataSearchDetailTypeFilter: action.dataSearchDetailTypeFilter
        }
      case actions.DATA_SEARCH_PROJECT_FILTER:
        return {
          ...state, 
          dataSearchProjectFilter: action.dataSearchProjectFilter
        }                        
      case actions.DATA_SEARCH_TEXT_FILTER:
        return {
          ...state, 
          dataSearchTextFilter: action.dataSearchTextFilter
        }
      case actions.DATA_SEARCH_SHOW_NOTIFICATION_FILTER:
        return {
          ...state, 
          dataSearchShowNotifications: action.dataSearchShowNotifications
        }        
      case actions.DATA_SEARCH_OPEN_FILTER:
        return {
          ...state, 
          dataSearchOpenFilter: action.dataSearchOpenFilter
        }
  



      case actions.DISTRIBUTION_LISTS_ACTIVE:
        return {
          ...state, 
          distributionListsActive: action.distributionListsActive
        }
      case actions.DISTRIBUTION_LISTS_INACTIVE:
        return {
          ...state, 
          distributionListsInactive: action.distributionListsInactive
        }
      case actions.DISTRIBUTION_LISTS_SEARCH_TEXT:
        return {
          ...state, 
          distributionListsSearchText: action.distributionListsSearchText
        }

      case actions.COMMUNICATION_OVERVIEW_FROM:
        return {
          ...state, 
          communicationOverviewFrom: action.communicationOverviewFrom
        }                
      case actions.COMMUNICATION_OVERVIEW_TO:
        return {
          ...state, 
          communicationOverviewTo: action.communicationOverviewTo
        }
      case actions.COMMUNICATION_OVERVIEW_SEARCH_VISIBILITY:
        return {
          ...state, 
          communicationOverviewSearchVisibility: action.communicationOverviewSearchVisibility
        } 
      case actions.COMMUNICATION_OVERVIEW_SEARCH_TEXT:
        return {
          ...state, 
          communicationOverviewSearchText: action.communicationOverviewSearchText
        }
      case actions.COMMUNICATION_OVERVIEW_TYPE:
        return {
          ...state, 
          communicationOverviewType: action.communicationOverviewType
        }

      case actions.COMMUNICATION_ADMINISTRATION_SEARCH_TEXT:
        return {
          ...state, 
          communicationAdministrationSearchText: action.communicationAdministrationSearchText
        }     
      case actions.COMMUNICATION_ADMINISTRATION_ACTIVE:
        return {
          ...state, 
          communicationAdministrationActive: action.communicationAdministrationActive
        }
      case actions.COMMUNICATION_ADMINISTRATION_INACTIVE:
        return {
          ...state, 
          communicationAdministrationInactive: action.communicationAdministrationInactive
        } 
      case actions.COMMUNICATION_ADMINISTRATION_FROM:
        return {
          ...state, 
          communicationAdministrationFrom: action.communicationAdministrationFrom
        }                
      case actions.COMMUNICATION_ADMINISTRATION_TO:
        return {
          ...state, 
          communicationAdministrationTo: action.communicationAdministrationTo
        }
      case actions.COMMUNICATION_ADMINISTRATION_TYPE:
        return {
          ...state, 
          communicationAdministrationType: action.communicationAdministrationType
        }        

      case actions.EMPLOYEE_HISTORY_MONTH:
        return {
          ...state, 
          employeeHistoryMonth: action.employeeHistoryMonth
        }
      case actions.EMPLOYEE_HISTORY_ACTIVE:
        return {
          ...state, 
          employeeHistoryActive: action.employeeHistoryActive
        }
      case actions.EMPLOYEE_HISTORY_INACTIVE:
        return {
          ...state, 
          employeeHistoryInactive: action.employeeHistoryInactive
        }
      case actions.EMPLOYEE_HISTORY_TIME_TRACKING_ACTIVE:
        return {
          ...state, 
          employeeHistoryTimeTrackingActive: action.employeeHistoryTimeTrackingActive
        }
      case actions.EMPLOYEE_HISTORY_TIME_TRACKING_INACTIVE:
        return {
          ...state, 
          employeeHistoryTimeTrackingInactive: action.employeeHistoryTimeTrackingInactive
        }

      case actions.TEAM_VACATION_OVERVIEW_COLUMN_MODE:
        return {
          ...state, 
          teamVacationOverviewColumnMode: action.teamVacationOverviewColumnMode
        }

      case actions.TIME_TRACK_CURRENT_LIST_ORDER_BY_LASTNAME:
        return {
          ...state, 
          timeTrackCurrentListOrderByLastname: action.timeTrackCurrentListOrderByLastname
        }

      case actions.TIME_TRACK_CURRENT_LIST_CHECKED_IN:
        return {
          ...state, 
          timeTrackCurrentListCheckedIn: action.timeTrackCurrentListCheckedIn
        }

      case actions.TIME_TRACK_CURRENT_LIST_CHECKED_OUT:
        return {
          ...state, 
          timeTrackCurrentListCheckedOut: action.timeTrackCurrentListCheckedOut
        }

      case actions.TIME_TRACK_CURRENT_LIST_BREAK_TIME:
          return {
            ...state, 
            timeTrackCurrentListBreakTime: action.timeTrackCurrentListBreakTime
          }
      
      case actions.TIME_TRACK_CURRENT_LIST_SEARCH_TERM:
          return {
            ...state, 
            timeTrackCurrentListSearchTerm: action.timeTrackCurrentListSearchTerm
          }

      case actions.TIME_TRACK_CURRENT_LIST_GROUP:
          return {
            ...state, 
            timeTrackCurrentListGroup: action.timeTrackCurrentListGroup
          }

      case actions.TIMEMANAGER_MONTH_DAY_SWITCH:
        return {
          ...state, 
          timemanagerMonthDaySwitch: action.timemanagerMonthDaySwitch
        }

      case actions.TIMEMANAGER_DATE:
        return {
          ...state, 
          timemanagerDate: action.timemanagerDate
        }

      case actions.TIMEMANAGER_MONTH:
        return {
          ...state, 
          timemanagerMonth: action.timemanagerMonth
        }

      case actions.TIMEMANAGER_EMPLOYEE_RID:
        return {
          ...state, 
          timemanagerEmployeeRid: action.timemanagerEmployeeRid
        }

      case actions.TEAM_END_OF_MONTH_OVERVIEW_MONTH:
        return {
          ...state, 
          teamEndOfMonthOverviewMonth: action.teamEndOfMonthOverviewMonth
        }
      case actions.TEAM_END_OF_MONTH_OVERVIEW_OPEN:
        return {
          ...state, 
          teamEndOfMonthOverviewOpen: action.teamEndOfMonthOverviewOpen
        }
      case actions.TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_EMP:
        return {
          ...state, 
          teamEndOfMonthOverviewCloseByEmp: action.teamEndOfMonthOverviewCloseByEmp
        }
      case actions.TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_TL:
        return {
          ...state, 
          teamEndOfMonthOverviewCloseByTL: action.teamEndOfMonthOverviewCloseByTL
        }
      case actions.TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_HR:
        return {
          ...state, 
          teamEndOfMonthOverviewCloseByHR: action.teamEndOfMonthOverviewCloseByHR
        }
      case actions.TEAM_END_OF_MONTH_OVERVIEW_TEXT_FILTER:
        return {
          ...state, 
          teamEndOfMonthOverviewTextFilter: action.teamEndOfMonthOverviewTextFilter
        }

      case actions.MAX_FILE_UPLOAD_SIZE:
        return {
          ...state, 
          maxFileUploadSize: action.maxFileUploadSize
        }

      case actions.LEFT_SIDE_MENU_IS_MINIMIZED:
        return {
          ...state, 
          leftSideMenuIsMinimized: action.leftSideMenuIsMinimized
        }

      case actions.PROGRAM_VERSION:
        return {
          ...state, 
          programVersion: action.programVersion
        }

      case actions.SYS_TEAMAPI7URL:
        return {
          ...state, 
          sysTeamApi7Url : action.sysTeamApi7Url
        }

    default:        
      return state
  } 
}

export default  currentUiSettings;